<p-toast key="toast" [style]="{marginTop: '80px'}"></p-toast>
<div class="card bg-light" >
    <div class="card-body">
        <div class="form-row">
            <label for="cmbSecured" class="col-sm-1 col-form-label prd-label">Sec/Unsec</label>
            <select id="cmbSecured" class="form-control col-sm-2" [(ngModel)]='myProperty.secured' (change)='dataChange()'>
                <option></option>
                <option *ngFor="let sec of securedTypeList">{{sec}}</option>
            </select>   
            <label for="txtAPN" class="col-sm-1 col-form-label prd-label">APN</label>
            <!--<p-inputMask [(ngModel)]="myProperty.apn" mask="999-999-999" unmask="true" (change)='dataChange()'></p-inputMask>-->
            <input id="txtAPN" title="Format: nnn-nnn-nnn, i.e. '123-456-778'" class="form-control col-sm-2" [(ngModel)]='myProperty.apn' (change)='dataChange()'>&nbsp; &nbsp;
            <button [hidden]="!allowAPNLookup" (click)="findAPN()" class="btn btn-info btn-sm" title="Use this button to search your database for an APN"> Find APN </button>
            <label for="txtUnsecuredNum" class="col-sm-2 col-form-label prd-label">Unsecured #</label>
            <input id="txtUnsecuredNum" class="form-control col-sm-2" [(ngModel)]='myProperty.unsecuredNum' (change)='dataChange()'>
            
        </div>
        <br/>
        <div class="form-row">          
                <label for="txtStrNbr" class="col-sm-1 col-form-label prd-label">Number</label>
                <input id="txtStrNbr" class="form-control col-sm-2" [(ngModel)]='myProperty.strNum' (change)='dataChange()'>
                <label for="txtStreet" class="col-sm-1 col-form-label prd-label">Street</label>
                <input id="txtStreet" class="form-control col-sm-2" [(ngModel)]='myProperty.street' (change)='dataChange()' maxlength="100">
                <label for="txtUnit" class="col-sm-1 col-form-label prd-label">Unit</label>
                <input id="txtUnit" class="form-control col-sm-1 prd-small">
                <label for="cmbCity" class="col-sm-1 col-form-label prd-label" >City</label>
                <select id="cmbCity" class="form-control col-sm-2" [(ngModel)]='myProperty.city' (change)='dataChange()'>
                    <option></option>
                    <option *ngFor="let city of cityList">{{city}}</option>
                </select>   
        </div>
        <br />
        <div class="form-row">
            <label for="txtTRA" class="col-sm-1 col-form-label prd-label">Tax Rate Area</label>
            <input id="txtTRA" class="form-control col-sm-2" [(ngModel)]='myProperty.taxRateArea' (change)='dataChange()'>
            <label for="cmbType" class="col-sm-1 col-form-label prd-label">Type</label>
            <select id="cmbType" class="form-control col-sm-4" [(ngModel)]='myProperty.type' (change)='dataChange()'>
                <option></option>
                <option *ngFor="let prop of propTypeList">{{prop}}</option>
            </select>   
           <label for="txtUseCode" class="col-sm-1 col-form-label prd-label">Use Code</label>
            <input disabled id="txtUseCode" class="form-control col-sm-2" [(ngModel)]='myProperty.useCode' (change)='dataChange()'>
        </div>
        <br />
        <div class="form-row">
            <label for="chkOwnerOccupied" class="col-sm-1 col-form-label prd-label">Owner Occupied Single Family</label>
            <input id="chkOwnerOccupied" type="checkbox" class="form-control col-sm-2" [(ngModel)]='myProperty.ownOccupy' (change)='dataChange()'>
            <label for="chkMismatch" class="col-sm-2 offset-1 col-form-label prd-label">APN/Situs Mismatch</label>
            <input id="chkMismatch" type="checkbox" class="form-control col-sm-1" [(ngModel)]='myProperty.apnMismatch' (change)='dataChange()'>    
        </div>
    </div>
</div>

